import React from 'react';
import {
  MDBCard,
  MDBCardTitle,
  MDBCardText,
  MDBContainer,
  MDBRow,
  MDBIcon,
} from 'mdbreact';
import { Link } from 'react-router-dom';

import NavBar from '../../components/NavBar';
import img from '../../assets/images.jpg';
import gerenciaImg from '../../assets/gerencia.jpg';
import cargosImg from '../../assets/cargos.jpg';
import ocorrenciaImg from '../../assets/ocorrencia.jpg';
import frotaImg from '../../assets/frota.jpg';
import monitoramento from '../../assets/monitoramento.png';
import parteDiaria from '../../assets/partediaria.png';
import ocrImg from '../../assets/ocr.jpg';
import nuint from '../../assets/nuint2.png';
// import { Link } from '@material-ui/core';
const Adm = /* props */ () => {
  return (
    <>
      <NavBar />
      <MDBContainer fluid>
        {/* espacamento  */}

        <MDBRow className="d-flex justify-content-center">
          <MDBCard
            style={{
              backgroundImage: `url(${img})`,
              backgroundSize: 'cover',
            }}
            className="justify-content-between card-body col-12 col-md-5 mr-2 ml-2 mt-3 mt-md-0 blue-grey-text text-center"
          >
            <MDBCardTitle className="h5">GESTÃO DE EFETIVO</MDBCardTitle>
            <MDBCardText className="grey-text text-left">
              Registrar o ingresso do servidor na Secretária de Governo.
            </MDBCardText>

            <div
              style={{ borderTop: '1px rgba(0,0,0,0.1) solid' }}
              className="flex-row d-flex justify-content-around  pt-3 mt-3"
            >
              <Link
                to="/usuarios"
                className="d-flex flex-column align-items-center blue-grey-text"
              >
                <span style={{ fontSize: 10, marginBottom: 5 }}>
                  Estatísticas
                </span>
                <MDBIcon icon="chart-pie" size="2x" />
              </Link>
              <Link
                to="/usuarios"
                className="d-flex flex-column align-items-center blue-grey-text"
              >
                <span style={{ fontSize: 10, marginBottom: 5 }}>Listar</span>
                <MDBIcon icon="list" size="2x" />
              </Link>
            </div>
          </MDBCard>
          <MDBCard
            style={{
              backgroundImage: `url(${frotaImg})`,
              backgroundSize: 'cover',
            }}
            className="justify-content-between card-body col-12 col-md-3 mr-2 ml-2 blue-grey-text text-center"
          >
            <MDBCardTitle className="h5">GESTÃO DE FROTA</MDBCardTitle>

            <MDBCardText className="grey-text text-left">
              Controle dos veículos empregados na Secretária de Governo.
            </MDBCardText>

            <div
              style={{ borderTop: '1px rgba(0,0,0,0.1) solid' }}
              className="flex-row d-flex justify-content-around pt-3 mt-3 "
            >
              <Link
                to="/frota"
                className="d-flex flex-column align-items-center blue-grey-text"
              >
                <span style={{ fontSize: 10, marginBottom: 5 }}>
                  Relatórios
                </span>

                <MDBIcon icon="list" size="2x" />
              </Link>
            </div>
          </MDBCard>
          <MDBCard
            style={{
              backgroundImage: `url(${parteDiaria})`,
              backgroundSize: 'cover',
            }}
            className="justify-content-between card-body col-12 col-md-3 mr-2 ml-2  blue-grey-text text-center"
          >
            <MDBCardTitle className="h5">GESTÃO DE PATRIMÔNIO</MDBCardTitle>

            <MDBCardText className="grey-text text-left">
              Registrar o ingresso de novos cargos e administrar os existentes,
              Assim como calcular o custo operacional da Operação.
            </MDBCardText>

            <div
              style={{ borderTop: '1px rgba(0,0,0,0.1) solid' }}
              className="flex-row d-flex justify-content-around pt-3 mt-3 "
            >
              <Link
                to="/patrimonio"
                className="d-flex flex-column align-items-center blue-grey-text"
              >
                <span style={{ fontSize: 10, marginBottom: 5 }}>Listar</span>

                <MDBIcon icon="list" size="2x" />
              </Link>
            </div>
          </MDBCard>
        </MDBRow>

        <MDBRow className="d-flex justify-content-center">
          <MDBCard
            style={{
              backgroundImage: `url(${ocorrenciaImg})`,
              backgroundSize: 'cover',
            }}
            className="justify-content-between card-body col-12 col-md-3 mr-2 ml-2 mt-3 blue-grey-text text-center"
          >
            <MDBCardTitle className="h5">GESTÃO DE OCORRÊNCIAS</MDBCardTitle>

            <MDBCardText className="grey-text text-left">
              Adicionar novas ocorrências, editar e extrair estatísticas de
              ocorrências registradas.
            </MDBCardText>

            <div
              style={{ borderTop: '1px rgba(0,0,0,0.1) solid' }}
              className="flex-row d-flex justify-content-around pt-3 mt-3"
            >
              <Link
                to="/usuarios"
                className="d-flex flex-column align-items-center blue-grey-text"
              >
                <span style={{ fontSize: 10, marginBottom: 5 }}>
                  Estatísticas
                </span>
                <MDBIcon icon="chart-pie" size="2x" />
              </Link>
              <Link
                to="/usuarios"
                className="d-flex flex-column align-items-center blue-grey-text"
              >
                <span style={{ fontSize: 10, marginBottom: 5 }}>Listar</span>
                <MDBIcon icon="list" size="2x" />
              </Link>
            </div>
          </MDBCard>
          <MDBCard
            style={{
              backgroundImage: `url(${monitoramento})`,
              backgroundSize: 'cover',
            }}
            className="justify-content-between card-body col-12 col-md-3 mr-2 ml-2 mt-3 blue-grey-text text-center"
          >
            <MDBCardTitle className="h5">MONITORAMENTO</MDBCardTitle>

            <MDBCardText className="grey-text text-left">
              Controle de cameras dos postos fiscais no CICC, criação de
              relatórios e despacho de demandas.
            </MDBCardText>

            <div
              style={{ borderTop: '1px rgba(0,0,0,0.1) solid' }}
              className="flex-row d-flex justify-content-around pt-3 mt-3 "
            >
              <Link
                to="/usuarios"
                className="d-flex flex-column align-items-center blue-grey-text"
              >
                <span style={{ fontSize: 10, marginBottom: 5 }}>Veículos</span>
                <MDBIcon icon="car" size="2x" />
              </Link>
              <Link
                to="/usuarios"
                className="d-flex flex-column align-items-center blue-grey-text"
              >
                <span style={{ fontSize: 10, marginBottom: 5 }}>
                  Relatórios
                </span>

                <MDBIcon icon="clipboard" size="2x" />
              </Link>
            </div>
          </MDBCard>
          <MDBCard
            style={{
              backgroundImage: `url(${parteDiaria})`,
              backgroundSize: 'cover',
            }}
            className="justify-content-between card-body col-12 col-md-5 mr-2 ml-2 mt-3 blue-grey-text text-center"
          >
            <MDBCardTitle className="h5">PARTE DIÁRIA</MDBCardTitle>

            <MDBCardText className="grey-text text-left">
              Alterações diárias como: falta de servidores, avaria veicular,
              acidente e etc.
            </MDBCardText>

            <div
              style={{ borderTop: '1px rgba(0,0,0,0.1) solid' }}
              className="flex-row d-flex justify-content-around pt-3 mt-3"
            >
              <Link
                to="/usuarios"
                className="d-flex flex-column align-items-center blue-grey-text"
              >
                <span style={{ fontSize: 10, marginBottom: 5 }}>
                  Estatísticas
                </span>
                <MDBIcon icon="chart-pie" size="2x" />
              </Link>
              <Link
                to="/usuarios"
                className="d-flex flex-column align-items-center blue-grey-text"
              >
                <span style={{ fontSize: 10, marginBottom: 5 }}>Listar</span>
                <MDBIcon icon="list" size="2x" />
              </Link>
            </div>
          </MDBCard>
        </MDBRow>

        <MDBRow className="d-flex justify-content-left ml-0 ml-md-3">
          <MDBCard
            style={{
              backgroundImage: `url(${ocrImg})`,
              backgroundSize: 'cover',
            }}
            className="justify-content-between card-body col-12 col-md-5 mr-2 ml-2 mt-3 blue-grey-text text-center"
          >
            <MDBCardTitle className="h5">ANÁLISES DE CAMERAS OCR</MDBCardTitle>

            <MDBCardText className="grey-text text-left">
              Ferramenta de análise dos meta dados das câmeras OCR das rodovias
              do estado do Rio de Janeiro.
            </MDBCardText>

            <div
              style={{ borderTop: '1px rgba(0,0,0,0.1) solid' }}
              className="flex-row d-flex justify-content-around pt-3 mt-3"
            >
              <Link
                to="/usuarios"
                className="d-flex flex-column align-items-center blue-grey-text"
              >
                <span style={{ fontSize: 10, marginBottom: 5 }}>
                  Estatísticas
                </span>
                <MDBIcon icon="chart-pie" size="2x" />
              </Link>
            </div>
          </MDBCard>

          <MDBCard
            style={{
              backgroundImage: `url(${gerenciaImg})`,
              backgroundSize: 'cover',
            }}
            className="justify-content-between card-body col-12 col-md-3 mr-2 ml-2 mt-3 blue-grey-text text-center"
          >
            <MDBCardTitle className="h5">DENÚNCIAS</MDBCardTitle>

            <MDBCardText className="grey-text text-left">
              Informações de denúncias da Central Disque Denúncia
            </MDBCardText>
            <div
              style={{ borderTop: '1px rgba(0,0,0,0.1) solid' }}
              className="flex-row d-flex justify-content-around pt-3 mt-3"
            >
              <Link
                to="/usuarios"
                className="d-flex flex-column align-items-center blue-grey-text"
              >
                <span style={{ fontSize: 10, marginBottom: 5 }}>
                  Estatísticas
                </span>
                <MDBIcon icon="chart-pie" size="2x" />
              </Link>
            </div>
          </MDBCard>
        </MDBRow>

        <br />
        <br />
      </MDBContainer>
    </>
  );
};

export default Adm;
